export default __webpack_public_path__ + "static/media/logo1.80f266c8.svg";